<template lang="pug">
.check-input-ok-cancel-modal
  b-modal(v-model="_value" :size="size" @ok="ok" hide-header no-close-on-backdrop no-close-on-esc)
    .check-input-ok-cancel-modal-body
      .div.mb-2(style="font-weight:bold; font-size:18px;") ファイルのアップロードに失敗しました
      .confirm
        div.error-message.mb-2 添付したファイルの送信前／送信中に「ファイル削除」「ファイル名変更」「フォルダ移動」した可能性があります。
        div 添付されたファイルを削除しました。
        div.mb-2 お手数ですが再度ファイルを添付し直して再実行してください。
        label
          input(type="checkbox" @click="checked = !checked")
          span 確認しました

    template(#modal-footer="{ ok }")
      button.btn.modal-ok-btn(v-if="checked" type="button" @click="ok()") {{ okButtonLabel }}
      button.btn.modal-ok-btn.disable(v-else type="button" disabled) {{ okButtonLabel }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### FileUploadErrorModal
 */
@Component
export default class FileUploadErrorModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** モーダルサイズ */
  @Prop({ default: () => "md" })
  size!: string;
  /** OKボタンラベル */
  @Prop({ default: () => "閉じる" })
  okButtonLabel!: string;

  /** 確認しました */
  checked: boolean = false;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * OKボタン押下イベント
   */
  public ok(): void {
    this.$emit("ok");
    this.checked = false;

    return;
  }
}
</script>
